import React from 'react';
import classNames from 'classnames/bind';
import { IconArrowsRight } from '@carnica/graphics';
import { Button } from '@carnica/ui-kit';
import { RESULT_TEXT } from "../../../utils/constants";
import { Metric } from "../../../../../metric";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var FooterButton = function FooterButton(_ref) {
  var href = _ref.href;
  return /*#__PURE__*/React.createElement("nav", {
    className: cx('footer-nav__wrapper')
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      headerMetric: ['handleClickSearchButtonAllResult']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cx('footer-nav__button'),
    href: href,
    iconRight: IconArrowsRight,
    iconRightView: "background",
    mode: "inline",
    tagName: "a"
  }, RESULT_TEXT)));
};